// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"393":"3a269689","888":"b06cc67f"}[chunkId] + ".css";
};